import { DashboardConfiguration } from 'types/dashboard';
import {
  DataWidget,
  FilesSearchWidget,
  FilesWidget,
  MultiStreamWidget,
} from 'types/dashboard_widget';

const DEMOGRAPHICS_AGE_AND_GENDER_DISTRIBUTION = new DataWidget(
  crypto.randomUUID(),
  'Age & Gender Distribution',
  'pie',
  {
    metric: 'Object Count (Distinct)',
    rowLimit: 25,
    dimensions: [
      {
        columnName: 'object_attributes',
      },
    ],
    sort: 'DESC',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'demographics',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'object_label',
            operator: 'EQUALS',
            value: 'person',
            or: [
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'head',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'face',
              },
            ],
          },
        ],
      },
    ],
  },
  { h: 2, w: 4, x: 0, y: 0 }
);

const DEMOGRAPHICS_AGE_AND_GENDER_DISTRIBUTION_BY_TIME = new DataWidget(
  crypto.randomUUID(),
  'Age & Gender Distribution By Time',
  'timeseries-bar-stacked',
  {
    metric: 'Object Count (Distinct)',
    dimensions: [
      {
        columnName: 'object_attributes',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'demographics',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'object_label',
            operator: 'EQUALS',
            value: 'person',
            or: [
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'head',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'face',
              },
            ],
          },
        ],
      },
    ],
  },
  { h: 2, w: 4, x: 4, y: 0 }
);

const DEMOGRAPHICS_GENDER_DETECTIONS = new DataWidget(
  crypto.randomUUID(),
  'Gender Detections',
  'leaderboard-table',
  {
    metric: 'Object Count (Distinct)',
    sort: 'DESC',
    rowLimit: 10,
    dimensions: [
      {
        columnName: 'timestamp',
      },
      {
        columnName: 'source_name',
      },
      {
        columnName: 'object_label',
      },
      {
        columnName: 'object_attributes',
      },
    ],
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'demographics',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'object_label',
            operator: 'EQUALS',
            value: 'person',
            or: [
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'head',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'face',
              },
            ],
          },
        ],
      },
    ],
  },
  { h: 2, w: 8, x: 0, y: 2 }
);

const DEMOGRAPHICS_AGE_AND_GENDER_DISTRIBUTION_BY_DAY_OF_WEEK = new DataWidget(
  crypto.randomUUID(),
  'Age & Gender Distribution By Day of Week',
  'timeseries-heatmap',
  {
    metric: 'Object Count (Distinct)',
    dimensions: [
      {
        columnName: 'object_attributes',
      },
    ],
    granularity: 'DAY',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'demographics',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'object_label',
            operator: 'EQUALS',
            value: 'person',
            or: [
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'head',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'face',
              },
            ],
          },
        ],
      },
    ],
  },
  { h: 4, w: 4, x: 8, y: 0 }
);

const DEMOGRAPHICS_MALE_DISTRIBUTION_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Male Distribution By Source',
  'timeseries-bar-stacked',
  {
    metric: 'Object Count (Distinct)',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'demographics',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'object_label',
            operator: 'EQUALS',
            value: 'person',
            or: [
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'head',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'face',
              },
            ],
          },
          {
            id: crypto.randomUUID(),
            column: 'object_attributes',
            operator: 'LIKE',
            value: '%, male%',
          },
        ],
      },
    ],
  },
  { h: 2, w: 4, x: 0, y: 4 }
);

const DEMOGRAPHICS_FEMALE_DISTRIBUTION_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Female Distribution By Source',
  'timeseries-bar-stacked',
  {
    metric: 'Object Count (Distinct)',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'demographics',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'object_attributes',
            operator: 'LIKE',
            value: '%female%',
          },
          {
            id: crypto.randomUUID(),
            column: 'object_label',
            operator: 'EQUALS',
            value: 'person',
            or: [
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'head',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'face',
              },
            ],
          },
        ],
      },
    ],
  },
  { h: 2, w: 4, x: 4, y: 4 }
);

const LICENSE_PLATE_RECOGNITION_WATCHLIST_HITS = new DataWidget(
  crypto.randomUUID(),
  'LPR Watchlist Hits',
  'timeseries-bar-stacked',
  {
    metric: 'Event Count',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'event_type',
        operator: 'LIKE',
        value: '%watchlist%',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'metrics_tag',
            operator: 'EQUALS',
            value: 'lpr',
          },
        ],
      },
    ],
  },
  { h: 2, w: 4, x: 0, y: 0 }
);

const LICENSE_PLATE_RECOGNITION_LAST_100_LICENSE_PLATES = new DataWidget(
  crypto.randomUUID(),
  'Last 100 License Plates',
  'leaderboard-table',
  {
    metric: 'Object Count (Distinct)',
    rowLimit: 100,
    sort: 'DESC',
    dimensions: [
      {
        columnName: 'timestamp',
      },
      {
        columnName: 'object_label',
      },
      {
        columnName: 'object_attributes',
      },
    ],
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'lpr',
        or: [
          {
            id: crypto.randomUUID(),
            column: 'object_label',
            operator: 'EQUALS',
            value: 'car',
            or: [
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'truck',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'van',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'bus',
              },
              {
                id: crypto.randomUUID(),
                column: 'object_label',
                operator: 'EQUALS',
                value: 'license_plate',
              },
            ],
          },
        ],
      },
    ],
  },
  { h: 5, w: 4, x: 4, y: 0 }
);

const LICENSE_PLATE_RECOGNITION_LAST_100_LICENSE_PLATES_SEARCH =
  new FilesSearchWidget(
    crypto.randomUUID(),
    'LPR Watchlist Hits',
    {
      query: 'watchlist',
      sort_by: 'created_at',
      camera_ids: [],
      confidence: 0.5,
      stream_ids: [],
      gateway_ids: [],
      search_entities: ['events', 'objects'],
    },
    { h: 3, w: 4, x: 0, y: 2 }
  );

const LICENSE_PLATE_RECOGNITION_SNAPSHOTS = new FilesWidget(
  crypto.randomUUID(),
  'License Plate Snapshots (edit to add a filter for your LPR pipeline)',
  { node_ids: ['snapshot1'] },
  { h: 5, w: 4, x: 8, y: 5 }
);

const GATEWAY_HEALTH_GATEWAY_CPU_UTILIZATION_LAST_REPORTED = new DataWidget(
  crypto.randomUUID(),
  'Gateway CPU Utilization (Last Reported)',
  'timeseries-bar-grouped',
  {
    metric: 'Gateway CPU Utilization Latest',
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
    granularity: 'HOUR',
  },
  {
    h: 2,
    w: 12,
    x: 0,
    y: 0,
  }
);

const GATEWAY_HEALTH_GATEWAY_GPU_UTILIZATION = new DataWidget(
  crypto.randomUUID(),
  'Gateway GPU Utilization',
  'timeseries-bar-grouped',
  {
    metric: 'Gateway GPU Utilization Latest',
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 12, x: 0, y: 6 }
);

const GATEWAY_HEALTH_GATEWAY_DISK_UTILIZATION = new DataWidget(
  crypto.randomUUID(),
  'Gateway Disk Utilization',
  'timeseries-bar-grouped',
  {
    metric: 'Gateway Disk Usage Percent Latest',
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 12, x: 0, y: 10 }
);

const GATEWAY_HEALTH_GATEWAY_CPU_MEMORY = new DataWidget(
  crypto.randomUUID(),
  'Gateway CPU Memory',
  'timeseries-bar-grouped',
  {
    metric: 'Gateway CPU Memory Usage Percent Latest',
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 12, x: 0, y: 4 }
);

const GATEWAY_HEALTH_GATEWAY_GPU_MEMORY = new DataWidget(
  crypto.randomUUID(),
  'Gateway GPU Memory',
  'timeseries-bar-grouped',
  {
    metric: 'Gateway GPU Memory Usage Percent Latest',
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 12, x: 0, y: 8 }
);

const GATEWAY_HEALTH_LATEST_GATEWAY_CPU_UTILIZATION = new DataWidget(
  crypto.randomUUID(),
  'Latest Gateway CPU Utilization',
  'leaderboard-bar',
  {
    metric: 'Gateway CPU Utilization Latest',
    rowLimit: 10,
    sort: 'DESC',
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
  },
  { h: 4, w: 3, x: 0, y: 12 }
);

const GATEWAY_HEALTH_LATEST_GATEWAY_CPU_MEMORY = new DataWidget(
  crypto.randomUUID(),
  'Latest Gateway CPU Memory',
  'leaderboard-bar',
  {
    metric: 'Gateway CPU Memory Usage Percent Latest',
    rowLimit: 10,
    sort: 'DESC',
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
  },
  { h: 4, w: 3, x: 3, y: 12 }
);

const GATEWAY_HEALTH_LATEST_GATEWAY_GPU_MEMORY = new DataWidget(
  crypto.randomUUID(),
  'Latest Gateway GPU Memory',
  'leaderboard-bar',
  {
    sort: 'DESC',
    metric: 'Gateway GPU Memory Usage Percent Latest',
    rowLimit: 10,
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
  },
  { h: 4, w: 3, x: 6, y: 12 }
);

const GATEWAY_HEALTH_LATEST_GATEWAY_GPU_UTILIZATION = new DataWidget(
  crypto.randomUUID(),
  'Latest Gateway GPU Utilization',
  'leaderboard-bar',
  {
    metric: 'Gateway GPU Utilization Latest',
    rowLimit: 10,
    sort: 'DESC',
    dimensions: [
      {
        columnName: 'gateway_name',
      },
    ],
  },
  { h: 4, w: 3, x: 9, y: 12 }
);

const VIDEO_WALL_ALL_ONLINE_CAMERAS = new MultiStreamWidget(
  crypto.randomUUID(),
  'All online cameras',
  {
    status: ['online'],
    sources: ['camera_stream'],
  },
  false,
  { h: 6, w: 6, x: 0, y: 0 }
);

const VIDEO_WALL_ALL_ONLINE_ANALYTICS_STREAMS = new MultiStreamWidget(
  crypto.randomUUID(),
  'All online analytics streams',
  {
    status: ['online'],
    sources: ['pipeline_stream'],
  },
  false,
  { h: 6, w: 6, x: 6, y: 0 }
);

const MONITORING_ALL_ONLINE_CAMERAS = new MultiStreamWidget(
  crypto.randomUUID(),
  'All online cameras',
  {
    status: ['online'],
    sources: ['camera_stream'],
  },
  false,
  { h: 6, w: 3, x: 0, y: 0 }
);

const MONITORING_ALL_ONLINE_ANALYTICS_STREAMS = new MultiStreamWidget(
  crypto.randomUUID(),
  'All online analytics streams',
  {
    status: ['online'],
    sources: ['pipeline_stream'],
  },
  false,
  { h: 6, w: 3, x: 3, y: 0 }
);

const MONITORING_ALL_RECORDINGS = new FilesWidget(
  crypto.randomUUID(),
  'All Recordings',
  {},
  { h: 3, w: 3, x: 6, y: 0 }
);

const MONITORING_PEOPLE_ALARM_SECURITY_RECORDINGS = new FilesSearchWidget(
  crypto.randomUUID(),
  'People, Alarm, Security, Monitoring Recordings',
  {
    query: 'person alarm security monitoring',
    sort_by: 'created_at',
    camera_ids: [],
    confidence: 0.5,
    stream_ids: [],
    gateway_ids: [],
    search_entities: ['events', 'objects', 'texts'],
  },
  { h: 3, w: 3, x: 6, y: 3 }
);

const MONITORING_SECURITY_EVENTS = new DataWidget(
  crypto.randomUUID(),
  'Monitoring & Security Events',
  'timeseries-bar-grouped',
  {
    metric: 'Event Count',
    dimensions: [
      {
        columnName: 'event_type',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'monitoring',
        or: [
          {
            id: crypto.randomUUID(),
            column: 'metrics_tag',
            operator: 'EQUALS',
            value: 'security',
          },
        ],
      },
    ],
  },
  { h: 2, w: 3, x: 9, y: 0 }
);

const MONITORING_SECURITY_EVENTS_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Monitoring & Security Events By Source',
  'pie',
  {
    metric: 'Event Count',
    rowLimit: 10,
    sort: 'DESC',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'monitoring',
        or: [
          {
            id: crypto.randomUUID(),
            column: 'metrics_tag',
            operator: 'EQUALS',
            value: 'security',
          },
        ],
      },
    ],
  },
  { h: 2, w: 3, x: 9, y: 2 }
);

const WORKPLACE_SAFETY_EVENT_HISTORY = new DataWidget(
  crypto.randomUUID(),
  'Event History',
  'timeseries-heatmap',
  {
    metric: 'Event Count',
    dimensions: [
      {
        columnName: 'event_type',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'safety',
      },
    ],
  },
  { h: 2, w: 3, x: 0, y: 0 }
);

const WORKPLACE_SAFETY_TOP_EVENTS_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Top Events by Source',
  'leaderboard-table',
  {
    sort: 'DESC',
    metric: 'Event Count',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'safety',
      },
    ],
    rowLimit: 10,
    dimensions: [
      {
        columnName: 'source_name',
      },
      {
        columnName: 'event_type',
      },
    ],
  },
  { h: 2, w: 3, x: 3, y: 0 }
);

const WORKPLACE_SAFETY_EVENT_DISTRIBUTION_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Event distribution by Source',
  'pie',
  {
    metric: 'Event Count',
    rowLimit: 100,
    sort: 'DESC',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    filters: [
      {
        id: crypto.randomUUID(),
        value: 'safety',
        column: 'metrics_tag',
        operator: 'EQUALS',
      },
    ],
  },
  { h: 2, w: 3, x: 6, y: 0 }
);

const WORKPLACE_SAFETY_PPE_VIOLATION_EVENT_RECORDINGS = new FilesSearchWidget(
  crypto.randomUUID(),
  'PPE Violation Event Recordings',
  {
    query: 'ppe',
    sort_by: 'created_at',
    camera_ids: [],
    confidence: 0.5,
    stream_ids: [],
    gateway_ids: [],
    search_entities: ['events', 'objects'],
  },
  { h: 2, w: 3, x: 0, y: 4 }
);

const WORKPLACE_SAFETY_FIRE_EVENT_RECORDINGS = new FilesSearchWidget(
  crypto.randomUUID(),
  'Fire Event Recordings',
  {
    query: 'fire',
    sort_by: 'created_at',
    camera_ids: [],
    confidence: 0.5,
    stream_ids: [],
    gateway_ids: [],
    search_entities: ['objects'],
  },
  { h: 2, w: 3, x: 6, y: 4 }
);

const WORKPLACE_SAFETY_OSHA_COMPLIANCE_EVENT_RECORDINGS = new FilesSearchWidget(
  crypto.randomUUID(),
  'OSHA Compliance Event Recordings',
  {
    query: 'osha',
    sort_by: 'created_at',
    camera_ids: [],
    confidence: 0.5,
    stream_ids: [],
    gateway_ids: [],
    search_entities: ['events'],
  },
  { h: 2, w: 3, x: 3, y: 4 }
);

const WORKPLACE_SAFETY_WORKER_SAFETY_EVENT_RECORDINGS = new FilesSearchWidget(
  crypto.randomUUID(),
  'Worker Safety Event Recordings',
  {
    query: 'safety fall',
    sort_by: 'created_at',
    camera_ids: [],
    confidence: 0.5,
    stream_ids: [],
    gateway_ids: [],
    search_entities: ['events'],
  },
  { h: 2, w: 3, x: 9, y: 4 }
);

const WORKPLACE_SAFETY_PPE_VIOLATION_EVENTS = new DataWidget(
  crypto.randomUUID(),
  'PPE Violation Events',
  'timeseries-bar-grouped',
  {
    metric: 'Event Count',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'event_type',
        operator: 'LIKE',
        value: '%ppe%',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'metrics_tag',
            operator: 'EQUALS',
            value: 'safety',
          },
        ],
      },
    ],
  },
  { h: 2, w: 3, x: 0, y: 2 }
);

const WORKPLACE_SAFETY_OSHA_COMPLIANCE_EVENTS = new DataWidget(
  crypto.randomUUID(),
  'OSHA Compliance Events',
  'timeseries-bar-grouped',
  {
    metric: 'Event Count',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'event_type',
        operator: 'LIKE',
        value: '%OSHA%',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'metrics_tag',
            operator: 'EQUALS',
            value: 'safety',
          },
        ],
      },
    ],
  },
  { h: 2, w: 3, x: 3, y: 2 }
);

const WORKPLACE_SAFETY_FIRE_EVENTS = new DataWidget(
  crypto.randomUUID(),
  'Fire Events',
  'timeseries-bar-grouped',
  {
    metric: 'Event Count',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'event_type',
        operator: 'LIKE',
        value: '%fire%',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'metrics_tag',
            operator: 'EQUALS',
            value: 'safety',
          },
        ],
      },
    ],
  },
  { h: 2, w: 3, x: 6, y: 2 }
);

const WORKPLACE_SAFETY_EVENTS = new DataWidget(
  crypto.randomUUID(),
  'Workplace Safety Events',
  'timeseries-bar-grouped',
  {
    metric: 'Event Count',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'safety',
        and: [
          {
            id: crypto.randomUUID(),
            column: 'event_type',
            operator: 'LIKE',
            value: '%safety%',
            or: [
              {
                id: crypto.randomUUID(),
                column: 'event_type',
                operator: 'LIKE',
                value: '%fall%',
              },
            ],
          },
        ],
      },
    ],
  },
  { h: 2, w: 3, x: 9, y: 2 }
);

const WORKPLACE_SAFETY_EVENT_DISTRIBUTION_BY_TYPE = new DataWidget(
  crypto.randomUUID(),
  'Event distribution by Type',
  'pie',
  {
    metric: 'Event Count',
    rowLimit: 100,
    sort: 'DESC',
    dimensions: [
      {
        columnName: 'event_type',
      },
    ],
    filters: [
      {
        id: crypto.randomUUID(),
        column: 'metrics_tag',
        operator: 'EQUALS',
        value: 'safety',
      },
    ],
  },
  { h: 2, w: 3, x: 9, y: 0 }
);

const OCCUPANCY_AND_COUNTING_VISITOR_COUNT = new DataWidget(
  crypto.randomUUID(),
  'Visitor count',
  'timeseries-bar-stacked',
  {
    metric: 'Occupancy : Object Entered Sum',
    dimensions: [
      {
        columnName: 'roi_label',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 0, y: 2 }
);

const OCCUPANCY_AND_COUNTING_PEAK_OCCUPANCY = new DataWidget(
  crypto.randomUUID(),
  'Peak occupancy',
  'timeseries-bar-stacked',
  {
    metric: 'Occupancy : Max Occupancy',
    dimensions: [
      {
        columnName: 'roi_label',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 6, y: 4 }
);

const OCCUPANCY_AND_COUNTING_LINE_CROSSING_COUNTS = new DataWidget(
  crypto.randomUUID(),
  'Line crossing counts',
  'timeseries-bar-stacked',
  {
    metric: 'Line Counter : Total Objects Crossed Sum',
    dimensions: [
      {
        columnName: 'line_label',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 0, y: 0 }
);

const OCCUPANCY_AND_COUNTING_LINE_CROSSINGS_BY_TIME = new DataWidget(
  crypto.randomUUID(),
  'Line crossings by time',
  'timeseries-heatmap',
  {
    metric: 'Line Counter : Total Objects Crossed Sum',
    dimensions: [
      {
        columnName: 'line_label',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 3, y: 0 }
);

const OCCUPANCY_AND_COUNTING_LINE_CROSSINGS_TOTAL = new DataWidget(
  crypto.randomUUID(),
  'Line crossing totals',
  'counter',
  { metric: 'Line Counter : Total Objects Crossed Sum' },
  { h: 1, w: 3, x: 9, y: 0 }
);

const OCCUPANCY_AND_COUNTING_AVERAGE_OCCUPANCY = new DataWidget(
  crypto.randomUUID(),
  'Average occupancy',
  'timeseries-bar-stacked',
  {
    metric: 'Occupancy : Average Occupancy',
    dimensions: [
      {
        columnName: 'roi_label',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 0, y: 4 }
);

const OCCUPANCY_AND_COUNTING_AVERAGE_IN_ROI = new DataWidget(
  crypto.randomUUID(),
  'Average time in ROI',
  'timeseries-bar-stacked',
  {
    metric: 'Occupancy : Avg Wait Time',
    dimensions: [
      {
        columnName: 'roi_label',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 0, y: 6 }
);

const OCCUPANCY_AND_COUNTING_VISITORS_BY_TIME_OF_DAY = new DataWidget(
  crypto.randomUUID(),
  'Visitors by time of day heatmap',
  'timeseries-heatmap',
  {
    metric: 'Occupancy : Object Entered Sum',
    dimensions: [
      {
        columnName: 'roi_label',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 6, x: 6, y: 2 }
);

const OCCUPANCY_AND_COUNTING_LATEST_OCCUPANCY = new DataWidget(
  crypto.randomUUID(),
  'Latest occupancy',
  'counter',
  { metric: 'Occupancy : Latest Occupancy' },
  { h: 1, w: 3, x: 9, y: 1 }
);

const OCCUPANCY_AND_COUNTING_HIGHLY_ENGAGED_VISITORS = new DataWidget(
  crypto.randomUUID(),
  'Highly engaged visitors',
  'timeseries-bar-grouped',
  {
    metric: 'Occupancy : Number of Objects Above Max Waiting Time',
    dimensions: [
      {
        columnName: 'roi_label',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 6, x: 6, y: 6 }
);

const OCCUPANCY_AND_COUNTING_LINE_CROSSINGS_COUNTS_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Line crossing counts by Source',
  'timeseries-bar-stacked',
  {
    metric: 'Line Counter : Total Objects Crossed Sum',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 6, y: 0 }
);

const OCCUPANCY_AND_COUNTING_VISITOR_COUNT_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Visitor Count By Source',
  'timeseries-bar-stacked',
  {
    metric: 'Occupancy : Object Entered Sum',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 3, y: 2 }
);

const OCCUPANCY_AND_COUNTING_AVERAGE_TIME_IN_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Average time in Source',
  'timeseries-bar-stacked',
  {
    metric: 'Occupancy : Avg Wait Time',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 3, y: 6 }
);

const OCCUPANCY_AND_COUNTING_AVERAGE_OCCUPANCY_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Average occupancy by Source',
  'timeseries-bar-stacked',
  {
    metric: 'Occupancy : Average Occupancy',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 3, y: 4 }
);

const OCCUPANCY_AND_COUNTING_PEAK_OCCUPANCY_BY_SOURCE = new DataWidget(
  crypto.randomUUID(),
  'Peak occupancy by Source',
  'timeseries-bar-stacked',
  {
    metric: 'Occupancy : Max Occupancy',
    dimensions: [
      {
        columnName: 'source_name',
      },
    ],
    granularity: 'HOUR',
  },
  { h: 2, w: 3, x: 9, y: 4 }
);

export const DASHBOARD_TEMPLATES: Record<
  string,
  { templateName: string; configuration: DashboardConfiguration }
> = {
  DEMOGRAPHICS: {
    templateName: 'Demographics',
    configuration: {
      widgets: [
        DEMOGRAPHICS_AGE_AND_GENDER_DISTRIBUTION,
        DEMOGRAPHICS_AGE_AND_GENDER_DISTRIBUTION_BY_TIME,
        DEMOGRAPHICS_GENDER_DETECTIONS,
        DEMOGRAPHICS_AGE_AND_GENDER_DISTRIBUTION_BY_DAY_OF_WEEK,
        DEMOGRAPHICS_MALE_DISTRIBUTION_BY_SOURCE,
        DEMOGRAPHICS_FEMALE_DISTRIBUTION_BY_SOURCE,
      ],
    },
  },
  LICENSE_PLATE_RECOGNITION: {
    templateName: 'License Plate Recognition',
    configuration: {
      widgets: [
        LICENSE_PLATE_RECOGNITION_WATCHLIST_HITS,
        LICENSE_PLATE_RECOGNITION_LAST_100_LICENSE_PLATES,
        LICENSE_PLATE_RECOGNITION_LAST_100_LICENSE_PLATES_SEARCH,
        LICENSE_PLATE_RECOGNITION_SNAPSHOTS,
      ],
    },
  },
  GATEWAY_HEALTH: {
    templateName: 'Gateway Health',
    configuration: {
      widgets: [
        GATEWAY_HEALTH_GATEWAY_CPU_UTILIZATION_LAST_REPORTED,
        GATEWAY_HEALTH_GATEWAY_GPU_UTILIZATION,
        GATEWAY_HEALTH_GATEWAY_DISK_UTILIZATION,
        GATEWAY_HEALTH_GATEWAY_CPU_MEMORY,
        GATEWAY_HEALTH_GATEWAY_GPU_MEMORY,
        GATEWAY_HEALTH_LATEST_GATEWAY_CPU_UTILIZATION,
        GATEWAY_HEALTH_LATEST_GATEWAY_CPU_MEMORY,
        GATEWAY_HEALTH_LATEST_GATEWAY_GPU_MEMORY,
        GATEWAY_HEALTH_LATEST_GATEWAY_GPU_UTILIZATION,
      ],
    },
  },
  VIDEO_WALL: {
    templateName: 'Video Wall',
    configuration: {
      widgets: [
        VIDEO_WALL_ALL_ONLINE_CAMERAS,
        VIDEO_WALL_ALL_ONLINE_ANALYTICS_STREAMS,
      ],
    },
  },
  MONITORING: {
    templateName: 'Monitoring',
    configuration: {
      widgets: [
        MONITORING_ALL_ONLINE_CAMERAS,
        MONITORING_ALL_ONLINE_ANALYTICS_STREAMS,
        MONITORING_ALL_RECORDINGS,
        MONITORING_PEOPLE_ALARM_SECURITY_RECORDINGS,
        MONITORING_SECURITY_EVENTS,
        MONITORING_SECURITY_EVENTS_BY_SOURCE,
      ],
    },
  },
  WORKPLACE_SAFETY: {
    templateName: 'Workplace Safety',
    configuration: {
      widgets: [
        WORKPLACE_SAFETY_EVENT_HISTORY,
        WORKPLACE_SAFETY_TOP_EVENTS_BY_SOURCE,
        WORKPLACE_SAFETY_EVENT_DISTRIBUTION_BY_SOURCE,
        WORKPLACE_SAFETY_PPE_VIOLATION_EVENT_RECORDINGS,
        WORKPLACE_SAFETY_FIRE_EVENT_RECORDINGS,
        WORKPLACE_SAFETY_OSHA_COMPLIANCE_EVENT_RECORDINGS,
        WORKPLACE_SAFETY_WORKER_SAFETY_EVENT_RECORDINGS,
        WORKPLACE_SAFETY_PPE_VIOLATION_EVENTS,
        WORKPLACE_SAFETY_OSHA_COMPLIANCE_EVENTS,
        WORKPLACE_SAFETY_FIRE_EVENTS,
        WORKPLACE_SAFETY_EVENTS,
        WORKPLACE_SAFETY_EVENT_DISTRIBUTION_BY_TYPE,
      ],
    },
  },
  OCCUPANCY_AND_COUNTING: {
    templateName: 'Occupancy & Counting',
    configuration: {
      widgets: [
        OCCUPANCY_AND_COUNTING_VISITOR_COUNT,
        OCCUPANCY_AND_COUNTING_PEAK_OCCUPANCY,
        OCCUPANCY_AND_COUNTING_LINE_CROSSING_COUNTS,
        OCCUPANCY_AND_COUNTING_LINE_CROSSINGS_BY_TIME,
        OCCUPANCY_AND_COUNTING_LINE_CROSSINGS_TOTAL,
        OCCUPANCY_AND_COUNTING_AVERAGE_OCCUPANCY,
        OCCUPANCY_AND_COUNTING_AVERAGE_IN_ROI,
        OCCUPANCY_AND_COUNTING_VISITORS_BY_TIME_OF_DAY,
        OCCUPANCY_AND_COUNTING_LATEST_OCCUPANCY,
        OCCUPANCY_AND_COUNTING_HIGHLY_ENGAGED_VISITORS,
        OCCUPANCY_AND_COUNTING_LINE_CROSSINGS_COUNTS_BY_SOURCE,
        OCCUPANCY_AND_COUNTING_VISITOR_COUNT_BY_SOURCE,
        OCCUPANCY_AND_COUNTING_AVERAGE_TIME_IN_SOURCE,
        OCCUPANCY_AND_COUNTING_AVERAGE_OCCUPANCY_BY_SOURCE,
        OCCUPANCY_AND_COUNTING_PEAK_OCCUPANCY_BY_SOURCE,
      ],
    },
  },
};
